export const setDeviceQuery = async (data) => {
    return fetch('/domains/add-domain-gsc-data/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const deleteIgnoreItems = async (data) => {
    return fetch('/domains/ignored-keyword-url/', {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};
